import { useDecision } from '@optimizely/react-sdk'

import { type DashboardExperienceApiVersion, getDashboardExperienceCacheKey } from '../configs'

export const DASHBOARD_EXPERIENCE_V2_FEATURE_FLAG_KEY =
  'rockets_ofx_webclient_dashboard_experience_v2_feature'

export const getDashboardExperienceApiVersionFromDecision = (
  isV2Enabled: boolean,
): DashboardExperienceApiVersion => (isV2Enabled ? 'v2' : 'v1')

export const useDashboardExperienceApiConfig = () => {
  const [decision, isDecisionReady, hasDecisionTimedOut] = useDecision(
    DASHBOARD_EXPERIENCE_V2_FEATURE_FLAG_KEY,
  )
  const apiVersion = getDashboardExperienceApiVersionFromDecision(decision.enabled === true)

  return {
    apiVersion,
    cacheKey: getDashboardExperienceCacheKey(apiVersion),
    isReady: isDecisionReady || hasDecisionTimedOut,
  }
}
